// extracted by mini-css-extract-plugin
export default {"creditbtn":"sudexo_creditbtn__u9qCt"};